require('./bootstrap');
import Vue from 'vue';
import App from "./App.vue";
import axios from 'axios';
import VueAxios from 'vue-axios';
import vueCookies from 'vue-cookies';
import VueRouter from 'vue-router'
import routes from './router/index';
import VCalendar from 'v-calendar';
import * as VeeValidate from 'vee-validate';
// import bootstrapJs from 'bootstrap/dist/js/bootstrap.bundle.min';
import laravelVuePagination from './components/global/laravel-vue-pagination/src/LaravelVuePagination';
import 'bootstrap';

Vue.component('pagination', laravelVuePagination);
Vue.use(VueAxios, axios);
Vue.use(vueCookies);
// Vue.use(bootstrapJs);
Vue.use(VCalendar);
Vue.use(VeeValidate, {
    inject: true,
    fieldsBagName: '$veeFields',
    errorBagName: '$veeErrors'
  })

window.bootstrapJs = require('bootstrap');
window.vueEvent = new Vue();

Vue.use(VueRouter);
const router = new VueRouter({
    mode: 'history',
    routes: routes,
});

var vm = new Vue({
    router,
    render: (h) => h(App),
}).$mount("#app");
